;(function () {
  angular
    .module('contrast.notifications.settings.user')
    .factory(
      'notificationUserSettingsService',
      notificationUserSettingsServiceFactory
    )

  function notificationUserSettingsServiceFactory(
    NOTIFICATION_TYPE,
    NOTIFICATION_CHANNELS,
    NOTIFICATION_TYPE_OPTIONS
  ) {
    'ngInject'

    return {
      buildSettings: function ($scope, data) {
        var ALL_OPTION = NOTIFICATION_TYPE_OPTIONS.ALL
        var DEFAULT_APP_OBJECT = { value: ALL_OPTION, name: 'All Applications' }
        var DEFAULT_TRIGGER_OBJECT = { value: ALL_OPTION, name: 'All' }

        $scope.mail_enabled = data.mail_enabled

        if ($scope.mail_enabled) {
          $scope.settings.activity_summary.enabled =
            data.settings.activity_summary
        }

        var vulnSettings = $scope.settings['new_vulnerability']
        if (angular.isDefined(vulnSettings)) {
          vulnSettings.vulns_options = []
          vulnSettings.db.enabled = false
          vulnSettings.email.enabled = false
        }

        var triggers = data.settings.triggers
        var i
        for (i = 0; i < triggers.length; i++) {
          var type = triggers[i].notification_type
          var attackStatus = triggers[i].attack_status
          var ruleSeverities = triggers[i].rule_severities
          var serverEnvironments = triggers[i].server_environments
          var assetTypes = triggers[i].asset_types

          var channels = triggers[i].channels
          var hasChannelsEnabled = false
          var trigger
          for (var j = 0; j < channels.length; j++) {
            var channelType = channels[j].channel
            var channelStatus = channels[j].enabled
            hasChannelsEnabled = hasChannelsEnabled || channelStatus

            trigger = $scope.settings[type.toLowerCase()]

            if (trigger) {
              if (channelType === NOTIFICATION_CHANNELS.DATABASE) {
                trigger.db.enabled = trigger.db.enabled || channelStatus
              } else if (channelType === NOTIFICATION_CHANNELS.EMAIL) {
                trigger.email.enabled =
                  trigger.email.enabled ||
                  (channelStatus && $scope.mail_enabled)
              }
            }
          }

          if (type === NOTIFICATION_TYPE.NEW_ATTACK) {
            trigger = $scope.settings[type.toLowerCase()]

            if (trigger) {
              if (triggers[i].all_attack_status) {
                trigger.status = [DEFAULT_TRIGGER_OBJECT]
              } else if (attackStatus) {
                trigger.status = attackStatus
              }

              trigger.notify.enabled = triggers[i].notify_on_change
            }
          }
          if (type === NOTIFICATION_TYPE.NEW_VULNERABILITY) {
            trigger = $scope.settings[type.toLowerCase()]

            if (trigger) {
              if (
                triggers[i].all_rule_severities &&
                triggers[i].all_server_environments
              ) {
                trigger.vulns_options = [DEFAULT_TRIGGER_OBJECT]
              } else {
                if (ruleSeverities) {
                  ruleSeverities.forEach(function (severity) {
                    var object = _.find(
                      $scope.select.vulns_options,
                      function (option) {
                        return option.value === severity
                      }
                    )
                    if (object) {
                      trigger.vulns_options.push(object)
                    }
                  })
                }

                if (serverEnvironments) {
                  serverEnvironments.forEach(function (environment) {
                    var object = _.find(
                      $scope.select.vulns_options,
                      function (option) {
                        return option.value === environment
                      }
                    )
                    if (object) {
                      trigger.vulns_options.push(object)
                    }
                  })
                }
              }

              if (triggers[i].all_server_environments) {
                trigger.server_environments = [DEFAULT_TRIGGER_OBJECT]
              } else if (ruleSeverities) {
                trigger.server_environments = serverEnvironments
              }

              trigger.notify.enabled = triggers[i].notify_on_change
            }
          }
          if (type === NOTIFICATION_TYPE.NEW_ASSET) {
            trigger = $scope.settings[type.toLowerCase()]

            if (trigger) {
              if (triggers[i].all_asset_types) {
                trigger.assets = [DEFAULT_TRIGGER_OBJECT]
              } else if (assetTypes) {
                trigger.assets = assetTypes
              }
            }
          }

          if (trigger) {
            trigger.show_options = this.showOptions(
              trigger,
              $scope.mail_enabled
            )
          }
        }

        if (data.settings.all_apps) {
          $scope.settings.apps = [DEFAULT_APP_OBJECT]
        } else {
          for (i = 0; i < data.settings.apps.length; i++) {
            var app = data.settings.apps[i]
            $scope.settings.apps.push({ value: app.app_id, name: app.name })
          }
        }
      },
      showOptions: function (trigger, mailEnabled) {
        return (
          trigger.db.enabled === true ||
          (trigger.email.enabled === true && mailEnabled)
        )
      }
    }
  }
})()
